import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MyBookingsModal from "./MyBookingsModal";
import { api } from "../../api/api";
import Swal from "sweetalert2";
import Loader from "../Loader";


function MyBookingsCard({ booking }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [vehicle, setVehicle] = useState();
  const [loading, setLoading] = useState(false);
  const vehicleId = booking.vehicleId;
  console.log(booking.vehicleId);
  console.log(vehicleId);

  useEffect(() => {
    setLoading(true);
    api
      .post("/vehicles/getvehiclebyid", { vehicleId })
      .then((response) => {
        setVehicle(response.data.vehicle);
      })
      .catch((error) => console.log(error));
    setLoading(false);
  }, []);

  const handleViewDetails = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCancelBooking = () => {
    // First show a confirmation dialog
    Swal.fire({
      title: 'Cancel Booking',
      text: 'Are you sure you want to cancel this booking?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#6f48e5', // You can adjust this to match your theme
      cancelButtonColor: '#d33',     // You can adjust this to match your theme
      confirmButtonText: 'Yes, cancel it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      // If the user confirms (clicks "Yes")
      if (result.isConfirmed) {
        // Proceed with the API call to cancel the booking
        setLoading(true);
        api
          .post("/bookings/cancelBooking", { bookingId: booking._id })
          .then((response) => {
            setLoading(false);
            Swal.fire({
              icon: 'success',
              title: 'Booking Canceled',
              text: 'The booking has been canceled successfully.'
            }).then(() => {
              window.location.reload(); // Reload after user clicks "OK"
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Something went wrong while canceling the booking.'
            });
            console.error("Error canceling booking:", error);
          });
      }
      // If user clicks "No", nothing happens and dialog closes
    });
  };
  

  return (
    <>
      
      {loading && <div className="absolute inset-0 bg-white z-10"> <Loader/> </div>}
      
      {isModalOpen && (
        <MyBookingsModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          booking={booking}
        />
      )}
      <div className="max-w-sm bg-white border border-gray-200 rounded-lg shadow-sm md:hover:scale-105 transition-all duration-300 w-full">
        <a href="#">
          <img
            className="rounded-t-lg aspect-custom-4-3 object-cover w-full"
            src={vehicle?.imageURLs[0]}
            alt={vehicle?.name}
          />
        </a>
        <div className="flex flex-col gap-2 p-5 w-full ">
          <p className="mb-2 text-xl lg:text-2xl font-bold tracking-tight text-gray-900">
            {vehicle?.name}
          </p>

          <div className="flex justify-between md:flex-col lg:flex-row ">
            <div className="flex flex-row space-x-2">
              <p className="font-medium">Type:</p>
              <p className="mb-2 font-normal text-gray-500">{vehicle?.type}</p>
            </div>
            <div className="flex flex-row space-x-2">
              <p className="font-medium">City:</p>
              <p className="mb-2 font-normal text-gray-500">{vehicle?.city}</p>
            </div>
          </div>
          <div className="flex justify-between md:flex-col lg:flex-row ">
            <div className="flex flex-row space-x-2">
              <p className="font-medium">Available Seats:</p>
              <p className="mb-2 font-normal text-gray-500">
                {vehicle?.availableSeats}
              </p>
            </div>
            <div className="flex flex-row space-x-2">
              {booking.isAccepted === "accepted" ? (
                <span className="bg-green-100 text-green-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded-lg">
                  Accepted
                </span>
              ) : booking.isAccepted === "rejected" ? (
                <span className="bg-red-100 text-red-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded-lg">
                  Rejected
                </span>
              ) : (
                <span className="bg-yellow-100 text-yellow-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded-lg">
                  Pending
                </span>
              )}
            </div>
          </div>

          <div className="flex flex-col items-center w-full gap-2">
            <button
              className="inline-flex items-center px-3 py-2 text-sm font-medium text-purple-700 bg-purple-200 rounded-lg hover:bg-purple-100 focus:outline-none transition-all duration-700  justify-center w-full"
              onClick={handleViewDetails}
            >
              View Details
            </button>
            <button className="inline-flex items-center px-3 py-2 text-sm font-medium text-red-700 bg-red-200 rounded-lg hover:bg-red-100 focus:outline-none transition-all duration-700 w-full justify-center" onClick={handleCancelBooking}>
              Cancel Booking
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default MyBookingsCard;
